import React from "react";
import { Table as BootstrapTable } from "reactstrap";
import moment from "moment";

import { generateRandomKey, formatNumbers } from "../../../../config/helpers";

function Table(props) {
  return (
    props.data && (
      <BootstrapTable
        className="fund-price-date-range-table mt-2"
        bordered
        size="sm"
        responsive
      >
        <thead>
          <tr>
            <th className="py-2">SN</th>
            <th className="py-2">Month</th>
            <th className="py-2">Year</th>
            <th className="py-2">Amount</th>
            <th className="py-2">Date Submitted</th>
            <th className="py-2">Description</th>
          </tr>
        </thead>
        <tbody>
          {props.data.map((item, index) => (
            <tr className="text-center" key={generateRandomKey()}>
              <td>{index + 1}</td>
              <td>{moment(item.VALUE_DATE).format("MMM")}</td>
              <td>{moment(item.VALUE_DATE).format("YYYY")}</td>
              <td className="text-right">{formatNumbers(item.AMOUNT)}</td>
              <td>{moment(item.POSTED_DATE).format("MMMM DD, YYYY")}</td>
              <td>{item.DESCRIPTION}</td>
            </tr>
          ))}
        </tbody>
      </BootstrapTable>
    )
  );
}

export default Table;
